export const register = {
    title: '登録',
    passwordLabel: 'パスワード',
    confirmPassword: '新しいパスワードを再入力',
    buttonRegister: '登録',
    confirmPasswordLabel: 'パスワードを再入力',
    policy1: '私は以下に同意します',
    policy2: '利用規約',
    and: 'そして',
    policy3: 'プライバシーポリシー。',
    backToLogin: 'ログインに戻る',
    contentAfterRegister:
        '登録が完了して、おめでとうございます。メールをチェックしてアカウントを確認してください。受信箱に確認メールが表示されない場合は、スパム フォルダーを確認してください。',
};
